// import lazySizes from 'lazysizes';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/rias/ls.rias';
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

function replaceImageSizeSuffix(url, newSuffix) {
    const expr = /(?:_\d+x\d*|_x\d+)?(\.(?:jpe?g|png|gif|webp|svg)(?:\?.*)?)$/gi;
    return url.replace(expr, `_${newSuffix}$1`);
}

export function responsiveImageTag(image, srcset = null) {
    const imageUrl = typeof(image.url) !== 'object' ? image.url : image.url.src;
    const
        urlPattern = replaceImageSizeSuffix(imageUrl, '{width}x'),
        alt = image.altText || image.alt || '';
        let dataSrcSet = '',
        imageUrlPrepared = urlPattern;
    if(srcset !== null){
        imageUrlPrepared = imageUrl;
        const srcsetArr = srcset.split(',');
        for(let i = 0; i < srcsetArr.length; i++) {
            const singleSrcset = srcsetArr[i];
            const replace = `${singleSrcset}x`
            let replaceUrl = urlPattern.replace('{width}x', replace);
            dataSrcSet += replaceUrl + ' ' + singleSrcset+'w';
            if(i < srcsetArr.length)
                dataSrcSet += ','
        }

    }

    let img = `<img
        class="lazyload d-block w-100"
        src="https://cdn.shopify.com/s/files/1/1201/1688/files/popup_image_placeholder__white.jpg?v=1686581115"
        alt="${alt}"
        data-src="${imageUrlPrepared}"
        data-sizes="auto"
        data-srcset="${dataSrcSet}"
        />`;



    return img;
}

// export class ImageLoader {
//     constructor() {
//         // window.lazySizesConfig.init = false;
//         // this.initLazySizes();
//     }

//     initLazySizes() {
//         console.log('blabla');
//         const config = window.lazySizesConfig || (window.laziySizesConfig = {});
//         config.rias = {
//             widths: [190, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048],
//             absUrl: true
//         };
//         lazySizes.init();

//         window.replaceImageSizeSuffix = replaceImageSizeSuffix;
//     }
// }
